module.exports = __webpack_public_path__ + "img/111003.14c6963f.png";